function initClassWeek(){
  let weekValueList = [
    "星期一",
    "星期二",
    "星期三",
    "星期四",
    "星期五",
    "星期六",
    "星期日"
  ];
  let tempWeekList = [];
  for (let i = 0; i < 7; i++) {
    tempWeekList.push({
      code: i + 1,
      value: weekValueList[i]
    });
  }
  return tempWeekList;
}

let weekList = initClassWeek()

export default weekList;